import { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Quote } from '../../types';
import QuoteCard from './QuoteCard';

interface QuotesListProps {
  quotes: Quote[];
  initialDisplayCount?: number;
}

export default function QuotesList({ quotes, initialDisplayCount = 6 }: QuotesListProps) {
  const [displayCount, setDisplayCount] = useState(initialDisplayCount);
  
  const showMore = () => {
    setDisplayCount(prev => prev + 6);
  };

  const showLess = () => {
    setDisplayCount(initialDisplayCount);
  };

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {quotes.slice(0, displayCount).map((quote, index) => (
          <motion.div
            key={quote.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <QuoteCard quote={quote} />
          </motion.div>
        ))}
      </div>

      {quotes.length > initialDisplayCount && (
        <div className="flex justify-center">
          {displayCount < quotes.length ? (
            <button
              onClick={showMore}
              className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            >
              <ChevronDown size={20} />
              Show More Quotes
            </button>
          ) : (
            <button
              onClick={showLess}
              className="flex items-center gap-2 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              <ChevronUp size={20} />
              Show Less
            </button>
          )}
        </div>
      )}
    </div>
  );
}